// // export const API_BASE_URL = "http://192.168.1.120:5010/v1";

// export const API_BASE_URL = "http://api.examanalysis.otherideas.in/v1";

export const SUB_DOMAIN = "";
// // export const SUB_DOMAIN = "kvschool2";


export const API_BASE_URL = process.env.REACT_APP_API_URL;